<script setup>

</script>

<template>
  <div class="tw-bg-white tw-p-20 tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-y-12">
    <svg-vue
      icon="illustrations/sad-folders"
      class="tw-w-56"
    />

    <div class="tw-gap-6 tw-flex tw-flex-col tw-items-center">
      <span class="tw-font-bold tw-text-2xl tw-text-neutral-900">
        Oops! Something went wrong
      </span>

      <span class="tw-text-base tw-text-neutral-700">
        Something went wrong while running the audit, please contact support.
      </span>
    </div>
  </div>
</template>
